import { Song } from '@/interfaces';

export const inBuiltList: Song[] = [
  {
    album: {
      id: 2786257,
      name: 'WHICH',
      picUrl: 'https://p2.music.126.net/vrOG0hAhslI4djtZdMgE6g==/6044015418094303.jpg',
      tns: [],
      pic: 6044015418094303,
    },
    alias: [],
    artists: [
      {
        id: 18345,
        name: '96猫',
        tns: [],
        alias: [],
      },
    ],
    commentThreadId: 'R_SO_4_28403160',
    copyrightId: 663018,
    duration: 182987,
    id: 28403160,
    mvid: 0,
    name: 'トルコ行進曲 - オワタ＼(^o^)',
    cd: '1',
    position: 2,
    ringtone: '',
    rtUrl: null,
    status: 0,
    pstatus: 0,
    fee: 0,
    version: 6,
    songType: 0,
    mst: 9,
    score: 100,
    ftype: 0,
    rtUrls: [],
    privilege: {
      id: 28403160,
      fee: 0,
      payed: 0,
      st: 0,
      pl: 320000,
      dl: 320000,
      sp: 7,
      cp: 1,
      subp: 1,
      cs: false,
      maxbr: 320000,
      fl: 320000,
      toast: false,
      flag: 0,
      preSell: false,
    },
    source: null,
  },
  {
    album: {
      id: 55112,
      name: 'ジブリを聴きながら、上を向いて歩こう',
      picUrl: 'https://p2.music.126.net/GYWkXtrnAawOWO2nfLg3PA==/109951163028865726.jpg',
      tns: [],
      pic_str: '109951163028865726',
      pic: 109951163028865730,
    },
    alias: [
      '「千と千尋の神隠し」 主題歌',
    ],
    artists: [
      {
        id: 16605,
        name: '伊藤サチコ',
        tns: [],
        alias: [],
      },
    ],
    commentThreadId: 'R_SO_4_584155',
    copyrightId: 663018,
    duration: 228306,
    id: 584155,
    mvid: 0,
    name: 'いつも何度でも',
    cd: '1',
    position: 10,
    ringtone: '',
    rtUrl: null,
    status: 0,
    pstatus: 0,
    fee: 0,
    version: 63,
    songType: 0,
    mst: 9,
    score: 100,
    ftype: 0,
    rtUrls: [],
    privilege: {
      id: 584155,
      fee: 0,
      payed: 0,
      st: 0,
      pl: 320000,
      dl: 320000,
      sp: 7,
      cp: 1,
      subp: 1,
      cs: false,
      maxbr: 999000,
      fl: 320000,
      toast: false,
      flag: 0,
      preSell: false,
    },
    source: {
      title: '单曲搜索',
      link: '/search/m/?s=%E3%81%84%E3%81%A4%E3%82%82%E4%BD%95%E5%BA%A6%E3%81%A7%E3%82%82&type=1',
      fid: '32',
      fdata: 'いつも何度でも',
    },
  },
];
